// extracted by mini-css-extract-plugin
export default {"container":"Slider_container__Lk4H6","slide":"Slider_slide__Rdx1V"};